import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { Button, Container, DivAcoes, Header, TextoHeader } from "./style";
import { formatarDinheiro } from "_utils/Money";
import { FaEye, FaUser } from "react-icons/fa";
import { ModalDetalhesLotePagamento } from "../ModalDetalhesLotePagamento";
import { IDetalheLotePagamento } from "../../../../../interface/IDetalheLotePagamento";
import { utils, writeFileXLSX } from "xlsx";
import { LoadingEstatisticaLote } from "../LoadingEstatisticaLote";
import { HttpResponse } from "_services/api/HttpResponse";
import { HttpError } from "_services/api/HttpError";
import { IData } from "_services/api/interface/HttpResponse";
import { useEffect, useState } from "react";
import { IEstatisticasLotePagamento } from "../../../../../interface/IEstatisticasLotePagamento";
import { OpcoesExportar } from "../OpcoesExportar";
import { toastErro } from "components/Toast";
import { IRelatorioPagamentosDetalhado } from "../../../../../interface/IRelatorioPagamentosDetalhado";
import { converterDataBr, converterDataHoraBr } from "_utils/Data";
import { IListarPagamentoReprovadoFornecedor } from "../../../../../interface/IListarPagamentoReprovadoFornecedor";
import { StatusLoteReprovado } from "../StatusLoteReprovado";

interface IListarProps {
  dados: IListarPagamentoReprovadoFornecedor[];
  handleLimitChange: (e: number) => void;
  handlePageChange: (e: number) => void;
  totalRows: number;
  selectedRows: any[];
  loadingLista: boolean;
  linhasPorPagina: number;
  showModalDetalhesLotePagamento: boolean;
  dadosDetalhes: IDetalheLotePagamento[];
  handleCloseModalDetalhes: () => void;
  valorTotalLoteEscolhido: number | null;
  onClickVerDetalhes: (idLote: number) => void;
  buscarEstatisticasLotePagamento: (
    idLote: number,
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  buscarEstatisticasPagamento: (
    idProcessoFinanceiroAprovar: number,
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  onClickProcesso: (idProcesso: number) => void;
  relatorioDetalhado: (
    statusAprovacaoLote: "APROVADO" | "PENDENTE" | "REPROVADO",
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  buscarComprovantes: (
    idsLotes: number[],
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  numeroNfReciboEscolhido: string;
  onClickVerReciboNf: (idLote: number, numeroNfRecibo: string) => void;
  aba: string;
}

export function ListarReprovados({
  dados,
  handleLimitChange,
  handlePageChange,
  totalRows,
  loadingLista,
  linhasPorPagina,
  showModalDetalhesLotePagamento,
  dadosDetalhes,
  handleCloseModalDetalhes,
  valorTotalLoteEscolhido,
  onClickVerDetalhes,
  buscarEstatisticasLotePagamento,
  buscarEstatisticasPagamento,
  onClickProcesso,
  relatorioDetalhado,
  buscarComprovantes,
  selectedRows,
  numeroNfReciboEscolhido,
  onClickVerReciboNf,
  aba,
}: IListarProps) {
  const [estatisticasLotesPagamento, setEstatisticasLotesPagamento] = useState<
    IEstatisticasLotePagamento[]
  >([]);
  const [showModalExportar, setShowModalExportar] = useState<boolean>(false);

  useEffect(() => {
    if (aba !== "reprovados") return;

    const estatisticasIniciais = dados.map((item) => ({
      idLote: item.id,
      qtdProcessos: null,
      custoProcesso: null,
      servicoReceber: null,
      totalPagarFornecedor: null,
    }));
    setEstatisticasLotesPagamento(estatisticasIniciais);

    dados.forEach((item) => {
      carregarEstatisticasLote(item.id);
    });
  }, [dados]);

  const carregarEstatisticasLote = async (idLote: number) => {
    const { hasErro, data } = await buscarEstatisticasLotePagamento(idLote);

    setEstatisticasLotesPagamento((prev) =>
      prev.map((item) => {
        if (item.idLote != idLote) {
          return item;
        }

        return {
          idLote: idLote,
          qtdProcessos: hasErro ? 0 : data.qtdProcessos,
          totalPagarFornecedor: hasErro ? 0 : data.totalPagarFornecedor,
          custoProcesso: hasErro ? 0 : data.custoProcesso,
          servicoReceber: hasErro ? 0 : data.servicoReceber,
        };
      }),
    );
  };

  const columns: IColum<IListarPagamentoReprovadoFornecedor>[] = [
    {
      name: "Nº Recibo / NF",
      selector: ({
        numeroNfRecibo,
        id,
      }: IListarPagamentoReprovadoFornecedor) => (
        <div
          className="link-primary"
          title="NF/Recibo"
          style={{ cursor: "pointer" }}
          onClick={() => {
            onClickVerReciboNf(id, numeroNfRecibo);
          }}
        >
          {numeroNfRecibo}
        </div>
      ),
      width: "150px",
    },
    {
      name: "ID lote",
      selector: ({ id }: IListarPagamentoReprovadoFornecedor) => id,
      width: "90px",
    },
    {
      name: "Fornecedor",
      selector: ({ nomeFornecedor }: IListarPagamentoReprovadoFornecedor) =>
        nomeFornecedor ?? "-",
    },
    {
      name: <span>Usuário lançamento</span>,
      selector: ({
        responsavelLancamento,
      }: IListarPagamentoReprovadoFornecedor) => responsavelLancamento ?? "-",
    },
    {
      name: "Processos",
      selector: ({ id }: IListarPagamentoReprovadoFornecedor) => {
        return (
          <LoadingEstatisticaLote
            id={id}
            estatisticasLotesPagamento={estatisticasLotesPagamento}
            item={"qtdProcessos"}
          />
        );
      },
      width: "150px",
    },
    {
      name: <span>Total a pagar</span>,
      selector: ({ valorNfRecibo }: IListarPagamentoReprovadoFornecedor) =>
        valorNfRecibo ? formatarDinheiro(Number(valorNfRecibo)) : "-",
      width: "150px",
    },
    {
      name: <span>Data de reprovação</span>,
      selector: ({ dataValidacao }: IListarPagamentoReprovadoFornecedor) =>
        dataValidacao ? converterDataBr(dataValidacao) : "-",
    },
    {
      name: "Pagamento",
      selector: () => <StatusLoteReprovado />,
    },
    {
      name: <span>Usuário validação</span>,
      selector: ({ usuarioValidacao }: IListarPagamentoReprovadoFornecedor) =>
        usuarioValidacao ?? "-",
    },
    {
      name: "Ações",
      selector: ({ id }: IListarPagamentoReprovadoFornecedor) => (
        <FaEye
          title="Visualizar lote"
          onClick={() => onClickVerDetalhes(id)}
          style={{ cursor: "pointer" }}
        />
      ),
      width: "90px",
    },
  ];

  const abrirModalExportar = () => {
    setShowModalExportar(!showModalExportar);
  };

  const onClickDetalhado = async () => {
    setShowModalExportar(false);

    const { hasErro, data } = await relatorioDetalhado("REPROVADO");

    if (hasErro) {
      toastErro(
        data?.message ?? "Não foi possível gerar o relatório detalhado",
      );
      return;
    }

    const dadosPlanilha = data.map((item: IRelatorioPagamentosDetalhado) => {
      return {
        "ID PROCESSO": item?.idProcesso ? item?.idProcesso : "-",
        PLACA: item?.placa ? item?.placa : "-",
        RENAVAM: item?.renavam ? item?.renavam : "-",
        SERVIÇO: item?.servico ? item?.servico : "-",
        EMPRESA: item?.nomeEmpresa ? item?.nomeEmpresa : "-",
        "CNPJ/CPF FORNECEDOR": item?.cpfCnpjFornecedor
          ? item?.cpfCnpjFornecedor
          : "-",
        "NOME FORNECEDOR": item?.nomeFornecedor ? item?.nomeFornecedor : "-",
        "VALOR DO PAGAMENTO": item?.valorPagamento
          ? Number(item.valorPagamento)
          : 0,
        "CHAVE PIX": item?.chavePix ? item?.chavePix : "-",
        "TITULAR DA CONTA PIX": item?.titularPix ? item?.titularPix : "-",
        BANCO: item?.banco ? item?.banco : "-",
        AGÊNCIA: item?.agencia ? item?.agencia : "-",
        "CONTA CORRENTE": item?.contaCorrente ? item?.contaCorrente : "-",
        "CNPJ/CPF TITULAR CONTA CORRENTE": item?.cpfCnpjTitularContaCorrente
          ? item?.cpfCnpjTitularContaCorrente
          : "-",
        "TITULAR CONTA CORRENTE": item?.titularContaCorrente
          ? item?.titularContaCorrente
          : "-",
        "DATA/HORA INCLUSÃO": item?.dataInclusao
          ? converterDataHoraBr(item?.dataInclusao)
          : "-",
        "DATA/HORA VALIDAÇÃO": item?.dataHoraValidacao
          ? converterDataHoraBr(item?.dataHoraValidacao)
          : "-",
        "RESPONSÁVEL VALIDAÇÃO": item?.responsavelValidacao
          ? item?.responsavelValidacao
          : "-",
      };
    });

    const planilha = utils.json_to_sheet(dadosPlanilha);

    const colunaValor = 7;
    const range = utils.decode_range(planilha["!ref"] ?? "A1");
    for (let row = range.s.r + 1; row <= range.e.r; row++) {
      const cellRef = utils.encode_cell({ r: row, c: colunaValor });
      if (planilha[cellRef]) {
        planilha[cellRef].z = '"R$ "#,##0.00';
      }
    }

    planilha["!cols"] = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ];
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, planilha, "Detalhes");

    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, "0");
    const mes = String(hoje.getMonth() + 1).padStart(2, "0");
    const ano = hoje.getFullYear();
    const nomeArquivo = `PGTO_FORNECEDOR_${dia}-${mes}-${ano}_DETALHADO.xlsx`;
    writeFileXLSX(workBook, nomeArquivo);
  };

  const onClickComprovantes = async () => {
    setShowModalExportar(false);

    const { data, hasErro } = await buscarComprovantes(
      selectedRows.map((row) => row.id),
    );

    if (hasErro) {
      toastErro(data?.message ?? "Não foi possível baixar os comprovantes");
      return;
    }
  };

  return (
    <Container>
      <Header>
        <TextoHeader>Lotes reprovados</TextoHeader>
        <DivAcoes>
          <Button outline variante="primary" onClick={abrirModalExportar}>
            <FaUser /> Exportar
          </Button>
          <OpcoesExportar
            aberto={showModalExportar}
            onClickComprovantes={onClickComprovantes}
            onClickDetalhado={onClickDetalhado}
          />
        </DivAcoes>
      </Header>
      <hr />
      <Table
        keyField="id"
        totalRows={totalRows}
        pagination={true}
        columns={columns}
        data={dados}
        paginationRowsPerPageOptions={[30, 50, 100, 300]}
        loading={loadingLista}
        onChangeRowsPerPage={handleLimitChange}
        onChangePage={handlePageChange}
        noSubHeader
        possuiTooltip={false}
        rowsPerPage={linhasPorPagina}
        headerFixo
      />
      <ModalDetalhesLotePagamento
        show={showModalDetalhesLotePagamento}
        dados={dadosDetalhes}
        handleClose={handleCloseModalDetalhes}
        buscarEstatisticasPagamento={buscarEstatisticasPagamento}
        numeroNfRecibo={numeroNfReciboEscolhido}
        valorTotalLoteEscolhido={valorTotalLoteEscolhido}
        onClickProcesso={onClickProcesso}
      />
    </Container>
  );
}
